import styled from 'styled-components';
import { Column, Span, Button } from '../../UI';
import { Form } from 'formik';

export const StyledForm = styled(Form)`
    padding: 15px 0;
`;

export const StyledColumn = styled(Column)`
    padding: 10px 0;
`;

export const ForgotEmail = styled(Span)`
    font-size: 14px;
    line-height: 18px;
    color: #a6a6a6;

    &:hover {
        color: #763689;
        cursor: pointer;
    }
`;

export const StyledButton = styled(Button)`
    &.ui.button {
        padding: 4px 40px;
        font-size: 16px;
        font-weight: bold;
    }
`;
